var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#414141;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reports_active",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.1,46.6C40.1,46.6,40.1,46.6,40.1,46.6H5.7c-3.2,0-5.8-2.6-5.8-5.8V5.2c0-3.2,2.6-5.8,5.8-5.8h27 c0.5,0,1,0.2,1.4,0.5l11.2,10.8c0.4,0.4,0.6,0.9,0.6,1.4v28.6C46,44,43.3,46.6,40.1,46.6z M5.7,3.3c-1.1,0-1.9,0.9-1.9,1.9v35.5 c0,1.1,0.9,1.9,1.9,1.9h34.4c1.1,0,1.9-0.9,1.9-1.9V13L32,3.3H5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.2,14.6H32.6c-1.1,0-1.9-0.9-1.9-1.9V1.4c0-1.1,0.9-1.9,1.9-1.9s1.9,0.9,1.9,1.9v9.4h9.6 c1.1,0,1.9,0.9,1.9,1.9S45.2,14.6,44.2,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.4,38.3C19.4,38.3,19.4,38.3,19.4,38.3c-6.4,0-11.7-5.2-11.7-11.7S12.9,15,19.4,15c1.1,0,1.9,0.9,1.9,1.9 v7.8h7.8c0.5,0,1,0.2,1.4,0.6c0.4,0.4,0.6,0.9,0.6,1.4C31,33.1,25.8,38.3,19.4,38.3z M17.4,19.1c-3.4,0.9-5.8,3.9-5.8,7.5 c0,4.3,3.5,7.8,7.8,7.8c3.6,0,6.7-2.5,7.5-5.8h-7.5c-1.1,0-1.9-0.9-1.9-1.9V19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,28.6H19.4c-1.1,0-1.9-0.9-1.9-1.9V14.1c0-1,0.8-1.8,1.8-1.9c0.4,0,0.9-0.1,1.3-0.1c7.4,0,13.4,6,13.4,13.4 c0,0.4,0,0.9-0.1,1.3C33.8,27.8,33,28.6,32,28.6z M21.3,24.7H30c-0.4-4.6-4.1-8.3-8.7-8.7V24.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/Reports.543c8cd7e6f60161775a46718c5bf94c.svg";
export { ForwardRef as ReactComponent };